import { Fragment } from "react";
import React from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import $ from "jquery";
import { FaShoppingCart, FaCartPlus } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { CiCalendarDate } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { HiOutlineSquaresPlus } from "react-icons/hi2";


import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Modal } from "antd";
import { RiSailboatLine } from "react-icons/ri";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutocompleteValue } from "../../common/forms/Autocomplete";
import { AddNotification } from "../../Methods/Notificaition.jsx";
import NavBar from "../../common/forms/NavbarCopy";
import "../../../styles/BoatList.scss";
import "../../../styles/BoatResponsive.scss";
import boatg from "../../../images/boat/boatg.gif";
import { Loader } from "../../common/forms/Loading/Loader";
import { subDirectory } from "../../../config.json";
import LoginModal from ".././Modals/LoginModal";
import { SkBoatListCard, SkOtherServiceCard } from "../../common/skeleton/subcatCardSkeleton";
import { DataContext } from "../BoatStore/BoatData";
import BoatListCard from "./BoatListCard";
import BoatSummaryCard from "./BoatSummaryCard";
import CryptoJS from 'crypto-js';

$(document).mouseup(function (e) {
  console.log("55555");
  var container = $(".css-26l3qy-menu");
  console.log("666666", container);
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.hide();
  }
});

class BoatListAll extends React.Component {
  static contextType = DataContext;
  constructor(props) {
    super(props);
    this.state = {
      isBoatHouseName: false,
      isClassName: false,
      isDatePick: false,
      isClassPremium: false,
      boatClosed: false,
      isUser: false,

      isFilterIcon: false,
    };
  }

  encryptedValuesFun (value)  {
	  const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString();
	 
    if (encryptedValue) {
      return encryptedValue.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe encoding
    }
	}
  decryptedValuesFun = (value) => {
    if (!value) {
      return null;
    } else {
      value = value.replace(/-/g, '+').replace(/_/g, '/');
      const decrypted = CryptoJS.AES.decrypt(value, "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString(CryptoJS.enc.Utf8);
      if (decrypted) {
        return JSON.parse(decrypted);
      }
    }
  }
  componentDidMount = async () => {
    console.log(this.context, "context", this.context.state);
    await this.setState({ isClassName: false, isBoatHouseName: false, isDatePick: false });
    await this.context.getboatHouse();
    // let b1 = this.encryptedValuesFun('72')
    // console.log("componentDidMount",b1)
    // console.log("componentDidMount1",this.decryptedValuesFun("U2FsdGVkX18rpjmh0RxF99hDeg-KOHDtaKF6vHtg6pg"))
    const searchParams = new URLSearchParams(this.props.location.search);
    const stateParam = searchParams.get('BId');
    if (stateParam) {
      let BoatHouseId = this.decryptedValuesFun(stateParam)
      let BoatHouseName = this.context.state.boatHouse?.find(boatHouse => boatHouse.BoatHouseId == BoatHouseId)?.BoatHouseName;
      let BoatingType = this.context.state.boatHouse?.find(boatHouse => boatHouse.BoatHouseId == BoatHouseId)?.BoatingType;
      console.log("getting values",BoatHouseId,BoatHouseName)
      if(BoatHouseId && BoatHouseName){
        await this.context.updateSelectedBoatHouseData(BoatHouseId, BoatHouseName, new Date().toLocaleDateString('en-CA'),BoatingType);
        await this.context.getBoatTypeList(BoatHouseId);
        await this.context.getBoatHouseTimingData(BoatHouseId);
        await this.context.getAvailableBoat();
        await this.context.getGst();
        await this.context.getOtherServices(BoatHouseId);
      }else{
        this.props.history.push({
          pathname: `${subDirectory}/boat`,
        });
      }
      
    }
    else if (this.props.location?.state) {
      await this.context.updateSelectedBoatHouseData(this.props.location?.state?.BoatHouseId, this.props.location?.state?.BoatHouseName, this.props.location?.state?.TripDate,this.props.location?.state?.BoatingType);
      await this.context.getBoatTypeList(this.props.location?.state?.BoatHouseId);
      await this.context.getBoatHouseTimingData(this.props.location?.state?.BoatHouseId);
      await this.context.getAvailableBoat();
      await this.context.getGst();
      await this.context.getOtherServices(this.props.location?.state?.BoatHouseId);
      
    } else {
      this.props.history.push({
        pathname: `${subDirectory}/boat`,
      });
    }
    this.setState({ loading: false });
  };
  openBoatHouseName = async () => {
    await this.setState((prevState) => ({
      isBoatHouseName: !prevState.isBoatHouseName,
    }));
    if (this.state.isBoatHouseName) {
      await this.setState({ isClassName: false, isFilterIcon: false, isDatePick: false });
    }
    this.forceUpdate();
  };
  openFilterClassName = async () => {
    await this.setState((prevState) => ({
      isFilterIcon: !prevState.isFilterIcon,
    }));
    if (this.state.isFilterIcon) {
      await this.setState({ isClassName: false, isBoatHouseName: false, isDatePick: false });
    }
    this.forceUpdate();
  };
  openBoatClassName = async () => {
    await this.setState((prevState) => ({
      isClassName: !prevState.isClassName,
    }));
    if (this.state.isClassName) {
      await this.setState({ isBoatHouseName: false, isFilterIcon: false, isDatePick: false });
    }
    this.forceUpdate();
  };
  datePicker = async () => {
    await this.setState((prevState) => ({
      isDatePick: !prevState.isDatePick,
    }));
    if (this.state.isDatePick) {
      await this.setState({ isBoatHouseName: false, isFilterIcon: false, isClassName: false });
    }
    this.forceUpdate();
  };
  render() {

const IsBoathouse =
  this.context?.state?.selectedBoatHouseName
    ?.toLowerCase()
    ?.includes("boat") || false;

    return (
      <Fragment>
        <AddNotification visible={this.context.state.openNotification} variant={this.context.state.variant} message={this.context.state.message} onClose={() => this.context.setOpenNotification(false)} />
        {!this.context.state.loading && <NavBar {...this.props} />}
        <Loader fullPage loading={this.context.state.paymentloading} />
        <div className="hotelContainer">
          <Container fluid className="hotelSummary">
            <div>
              <Row className="img_containers">
                <Container fluid>
                  <div>
                    <Row className="hotelctner">
                      <Col md={9} className="colmar">
                        <Row className="room-bt">
                          <Col md={11}>
                            <Row>
                              <Container className="hotelList">
                                <div className=" hotel-search-bar  ">
                                  <div className="search-item mx-1 d-flex align-items-center searchchips" style={{  }} onClick={this.openBoatHouseName}>
                                    <label class="labelhotel mt-2 mr-2">
                                      <CiLocationOn className="location-icon" size="18px" style={{marginTop:"-1px",
                                      backgroundColor:"#f3f3f3",borderRadius:"50%", width:"22px", height:"22px"}} />

                                      {/* Boat House */}
                                    </label>
                                    <div className="w-100 mt-2 ">
                                      <AutocompleteValue
                                        menuIsOpen={this.state.isBoatHouseName}
                                        field="boathouse"
                                        name="boathouse"
                                        getOptionValue={(option) => option.BoatHouseId}
                                        getOptionLabel={(option) => option.BoatHouseName}
                                        options={this.context.state.boatHouse}
                                        value={this.context.state.boatHouse}
                                        // placeholder={"tour"}
                                        placeholder={this.context.state.selectedBoatHouseName}
                                        onChange={(e) => this.context.handleBoatHouseChange(e)}
                                        className="autocomplete-color mb-4"
                                        autoComplete="off"
                                        // required
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="search-item mx-1 d-flex align-items-center searchchips"
                                    style={{  }}
                                    onClick={() => {
                                      return this.state.isDatePick == false ? this.setState({ isDatePick: true, isBoatHouseName: false, isClassName: false }) : null;
                                    }}
                                  >
                                    <label class="labelhotel mb-2 mr-2" onClick={this.datePicker}>
                                      {/* <CiCalendarDate size="18px" style={{marginTop:"-9px"}} /> */}
                                      <CiCalendarDate className="location-icon" size="17px" style={{marginTop:"-1px",
                                       backgroundColor:"#f3f3f3",borderRadius:"50%", width:"23px", height:"22px"}} />

                                    </label>
                                    <div className="w-100">
                                      <DatePicker
                                        dateFormat=" eee, dd/MM/yyyy"
                                        onClick={this.datePicker}
                                        field="startDate"
                                        selected={this.context.state.startDate}
                                        onChange={(date) => {
                                          this.context.handleDateChange(date);
                                          return this.datePicker();
                                        }}
                                        className="boatdate"
                                        placeholder={this.context.state.startDate}
                                        open={this.state.isDatePick}
                                        minDate={new Date(this.context.state.MinDate)}
                                        disabledKeyboardNavigation
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="choosetitle">
                                  {this.context.state.selectedBoatHouseName} - <span className="subtitle">
  {this.context.state.BoatName === "Boating" && IsBoathouse ? this.context.state.BoatName : "Booking"}
</span>
                                </div>
                                {this.context.state.isBoatType && this.context.state.BoatName === "Boating" && (
                                  <div className="filterstyle" onClick={this.openFilterClassName}>
                                    <RiSailboatLine color="grey"  className="filtericon" />
                                    <AutocompleteValue field="BoatType" name="type" menuIsOpen={this.state.isFilterIcon} onChange={(e) => this.context.boatTypeChange(e)} className="hoteldest mb-2" getOptionValue={(option) => option.BoatTypeId} getOptionLabel={(option) => option.BoatType} options={this.context.state.boatType} value={this.context.state.boatType} autoComplete="off" required placeholder={this.context.state.selectedBoatTypeName} />
                                  </div>
                                )}
                                <div className="reacttabdiv">
                                  <Tabs
                                    selectedIndex={this.context.state.tabindex}
                                    //  onSelect={(index) => this.setState({ index })}
                                  >
                                    <TabList>
                                      {console.log("getting type",this.context.state.boatingTypeValue,this.context.state.tabindex)}
                                      {!this.context.state.isBoatCardListLoading && this.context.state.isBoatingListAvailable && this.context.state.boatingTypeValue =="Y" &&
                                        <Tab>
                                          <div onClick={() => this.context.Boatclick("Boating")}>
                                            <div className="tabname">{IsBoathouse ? "Boating" : "Booking"}</div>
                                          </div>
                                        </Tab>
                                      }

                                    {this.context.state.EntranceList?.length > 0 && this.context.state.boatingTypeValue !="Y" && (
                                        <Tab id="react-tabs-2">
                                          <div onClick={() => this.context.Boatclick("Entrance")}>
                                            <div className="tabname">Entrance Fee</div>
                                          </div>
                                        </Tab>
                                      )}
                                      
                                      {this.context.state.ParkingList?.length > 0 && (
                                        <Tab id="react-tabs-2">
                                          <div onClick={() => this.context.Boatclick("Parking")}>
                                            <div className="tabname">Parking</div>
                                          </div>
                                        </Tab>
                                      )}
                                      {this.context.state.OtherServicesList?.length > 0 && (
                                        <Tab id="react-tabs-4">
                                          <div onClick={() => this.context.Boatclick("Other Facilities")}>
                                            <div className="tabname">Other Facilities</div>
                                          </div>
                                        </Tab>
                                      )}
                                      {this.context.state.EntranceList?.length > 0 &&  this.context.state.boatingTypeValue =="Y" && (
                                        <Tab id="react-tabs-2">
                                          <div onClick={() => this.context.Boatclick("Entrance")}>
                                            <div className="tabname">Entrance Fee</div>
                                          </div>
                                        </Tab>
                                      )}
                                    </TabList>
                                    <div className="tabscroll">
                                      {this.context.state.boatingTypeValue =="Y" &&
                                        <TabPanel id="react-tabs-1">
                                          <div style={{ width: "100%" }}>{this.context.state.isBoatCardListLoading && <SkBoatListCard viewBox="0 0 700 300" />}</div>
                                          <div>{!this.context.state.isBoatCardListLoading && this.context.state.isBoatingListAvailable && <BoatListCard boatdata={this.context.state.boatAvailableList} IsBoathouse={IsBoathouse} />}</div>
                                          <div className="nodatafound align-center text-center mt-4">
                                            {!this.context.state.isBoatCardListLoading && !this.context.state.isBoatingListAvailable && (
                                              <div className="nodatafound align-center text-center mt-4">
                                                <div>
                                                  <img src={boatg} className="errorimg" />
                                                </div>
                                                <span class="notfud text-danger text-bold"> {this.context.state.noboat} </span>{" "}
                                              </div>
                                            )}
                                          </div>
                                        </TabPanel>
                                      }
                                      {this.context.state.EntranceList.length > 0 && this.context.state.boatingTypeValue !="Y" && (
                                        <TabPanel id="react-tabs-3">
                                          <div style={{ width: "100%" }}>{this.context.state.isOtherCardListLoading && <SkOtherServiceCard />}</div>
                                          <div style={{ padding: "1rem 1rem 10rem 1rem" }}>
                                            {!this.context.state.isOtherCardListLoading && this.context.state.isOtherServiceAvailable && (
                                              <>
                                                <Row>
                                                  {this.context.state.EntranceList.map((service) => (
                                                    <Col sm={4}>
                                                      <div 
                                                          className={this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)
                                                                      ?"addonserviceadd":"addonservice"}
                                                          onClick={() => 
                                                                        this.context.state.EntranceCart.every((servicecart) => servicecart.ServiceId != service.ServiceId) 
                                                                        ? this.context.AddIndividualEnteranceCart(service) : this.context.RemoveEntrance(service)
                                                                  }
                                                        >
                                                        
                                                        <div className="addontitle">
                                                          {service.CategoryName} - {service.ServiceName}
                                                        </div>
                                                        <div className={`addoncharge ${this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)?"color-white":""}`}>₹ {parseInt(service.ServiceTotalAmount || 0)}</div>
                                                      {/* {this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)&&
                                                      <div className="text-center mt-2">Already Selected</div>
                                                      } */}
                                                      </div>
                                                    </Col>
                                                  ))}
                                                </Row>
                                              </>
                                            )}
                                            <>
                                              {!this.context.state.isOtherCardListLoading && !this.context.state.isOtherServiceAvailable && (
                                                <div className="nodatafound align-center text-center mt-4">
                                                  <span class="notfud text-danger text-bold"> No Entrance Fee Available </span>{" "}
                                                </div>
                                              )}
                                            </>
                                          </div>
                                        </TabPanel>
                                      )}
                                     
                                      {this.context.state.ParkingList.length > 0 && (
                                        <TabPanel id="react-tabs-3">
                                          <div style={{ width: "100%" }}>{this.context.state.isOtherCardListLoading && <SkOtherServiceCard />}</div>
                                          <div style={{ padding: "1rem 1rem 10rem 1rem" }}>
                                            {!this.context.state.isOtherCardListLoading && this.context.state.isOtherServiceAvailable && (
                                              <>
                                                <Row style={{display:"flex", flexWrap:"wrap"}}>
                                                  {this.context.state.ParkingList.map((service) => (
                                                    <Col sm={4}>
                                                      <div 
                                                        className={this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)
                                                                    ?"addonserviceadd":"addonservice"}
                                                        onClick={() => 
                                                                      this.context.state.OtherserviceCart.every((servicecart) => servicecart.ServiceId != service.ServiceId) 
                                                                      ? this.context.AddOtherServicesCart(service) : this.context.RemoveOtherservice(service)
                                                                }
                                                      >
                                                        
                                                        <div className="addontitle"> {service.ServiceName}</div>
                                                        <div className={`addoncharge ${this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)?"color-white":""}`}>₹ {parseInt(service.ServiceTotalAmount || 0)}</div>
                                                        {/* {this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)&&
                                                      <div className="text-center mt-2">Already Selected</div>} */}
                                                      </div>
                                                    </Col>
                                                  ))}
                                                </Row>
                                              </>
                                            )}
                                            <>
                                              {!this.context.state.isOtherCardListLoading && !this.context.state.isOtherServiceAvailable && (
                                                <div className="nodatafound align-center text-center mt-4">
                                                  <span class="notfud text-danger text-bold"> No Parking Available </span>
                                                </div>
                                              )}
                                            </>
                                          </div>
                                        </TabPanel>
                                      )}
                                      {this.context.state.OtherServicesList.length > 0 && (
                                        <TabPanel id="react-tabs-3">
                                          <div style={{ width: "100%" }}>{this.context.state.isOtherCardListLoading && <SkOtherServiceCard />}</div>
                                          <div style={{ padding: "1rem 1rem 10rem 1rem" }}>
                                            {!this.context.state.isOtherCardListLoading && this.context.state.isOtherServiceAvailable && (
                                              <>
                                                <Row>
                                                  {this.context.state.OtherServicesList.map((service) => (
                                                    <Col sm={4}>
                                                      <div 
                                                          className={this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)
                                                                        ?"addonserviceadd":"addonservice"}
                                                          onClick={() => 
                                                                          this.context.state.OtherserviceCart.every((servicecart) => servicecart.ServiceId != service.ServiceId) 
                                                                          ? this.context.AddOtherServicesCart(service) : this.context.RemoveOtherservice(service)
                                                                  }
                                                      >
                                                        
                                                        <div className="addontitle">
                                                          {service.CategoryName} - {service.ServiceName}
                                                        </div>
                                                        <div className={`addoncharge ${this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)?"color-white":""}`}>₹ {parseInt(service.ServiceTotalAmount || 0)}</div>
                                                      {/* {this.context.state.OtherserviceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)&&
                                                      <div className="text-center mt-2">Already Selected</div>} */}
                                                      </div>
                                                    </Col>
                                                  ))}
                                                </Row>
                                              </>
                                            )}
                                            <>
                                              {!this.context.state.isOtherCardListLoading && !this.context.state.isOtherServiceAvailable && (
                                                <div className="nodatafound align-center text-center mt-4">
                                                  <span class="notfud text-danger text-bold"> No Other Facilities Available </span>{" "}
                                                </div>
                                              )}
                                            </>
                                          </div>
                                        </TabPanel>
                                      )}
                                      {this.context.state.EntranceList.length > 0 && this.context.state.boatingTypeValue =="Y" &&(
                                        <TabPanel id="react-tabs-3">
                                          <div style={{ width: "100%" }}>{this.context.state.isOtherCardListLoading && <SkOtherServiceCard />}</div>
                                          <div style={{ padding: "1rem 1rem 10rem 1rem" }}>
                                            {!this.context.state.isOtherCardListLoading && this.context.state.isOtherServiceAvailable && (
                                              <>
                                                <Row>
                                                  {this.context.state.EntranceList.map((service) => (
                                                    <Col sm={4}>
                                                      <div 
                                                          className={this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId) 
                                                                      ? "addonserviceadd" 
                                                                      : "addonservice"}
                                                          onClick={() => 
                                                            this.context.state.EntranceCart.every((servicecart) => servicecart.ServiceId != service.ServiceId) 
                                                            ? this.context.AddIndividualEnteranceCart(service) : this.context.RemoveEntrance(service)
                                                          }
                                                      >

                                                        
                                                        <div className="addontitle">
                                                          {service.CategoryName} - {service.ServiceName}
                                                        </div>
                                                        <div className={`addoncharge ${this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)?"color-white":""}`}>₹ {parseInt(service.ServiceTotalAmount || 0)}</div>
                                                      {/* {this.context.state.EntranceCart.some((servicecart) => servicecart.ServiceId == service.ServiceId)&&
                                                      <div className="text-center mt-2">Already Selected</div>} */}
                                                      </div>
                                                    </Col>
                                                  ))}
                                                </Row>
                                              </>
                                            )}
                                            <>
                                              {!this.context.state.isOtherCardListLoading && !this.context.state.isOtherServiceAvailable && (
                                                <div className="nodatafound align-center text-center mt-4">
                                                  <span class="notfud text-danger text-bold"> No Entrance Fee Available </span>{" "}
                                                </div>
                                              )}
                                            </>
                                          </div>
                                        </TabPanel>
                                      )}
                                    </div>
                                  </Tabs>
                                </div>
                              </Container>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={3} className="card-container">
                        <BoatSummaryCard IsBoathouse={IsBoathouse}/>
                      </Col>
                    </Row>
                  </div>
                </Container>
              </Row>
            </div>
          </Container>
        </div>
        <LoginModal
          visible={this.context.state.showLoginModal}
          hideFooter={true}
          onSubmit={this.context.loginUsers}
          showHeader={true}
          handleClose={() => {
            this.context.handleLoginClose();
          }}
        />
        <Modal centered wrapClassName="Notification-modal" title="TTDC" visible={this.context.state.isModalVisible} onOk={this.context.handleOk} onCancel={this.context.handleCancel} cancelButtonProps={{ style: { display: "none" } }} okButtonProps={{ size: "large", style: { opacity: "0.63" } }}>
          <p className="text-center info-icon">
            <AiOutlineInfoCircle style={{ fontSize: "72px" }} />
          </p>

          {this.context.state?.alertmessage === "slotcontent" ? (
            <div>
              <ul>
                <b>Time Slot(s) Blocked </b>
                {this.context.state?.TicketBlockedData?.map((blockdata, j) => {
                  return (
                    <li>
                      {blockdata.BoatSeater} - {blockdata.BoatType} {blockdata.TimeSlot}{" "}
                    </li>
                  );
                })}
              </ul>
              <ul>
                {" "}
                <b>But the other time slot(s)</b>{" "}
                {this.context.state?.TicketCanceledData?.map((canceldata, j) => {
                  return (
                    <li>
                      {canceldata.BoatSeater} - {canceldata.BoatType} {canceldata.TimeSlot}
                    </li>
                  );
                })}
                are not able to block as it has been booked now. Please go back and select the alternate time slot(s)
              </ul>
            </div>
          ) : (
            <p className="text-center notification-message mt-4">{this.context.state.alertmessage}</p>
          )}
        </Modal>
      </Fragment>
    );
  }
}
export default BoatListAll;
